import { Effect, Schema } from "effect";
import * as Arrows from "../game/arrows.ts";
import * as Errors from "./errors.ts";

// A measure is eight rows of four marks, "0" or "1", with one space between rows.
const Measure = Schema.String.check(
  Schema.isPattern(new RegExp(`^[01]{4}( [01]{4}){${String(Arrows.ROWS - 1)}}$`)),
);

// The file the page fetches; a chart with no measures would have nothing to loop on.
export const Chart = Schema.Struct({
  measures: Schema.Array(Measure).check(Schema.isMinLength(1)),
}).annotate({ identifier: "@beatdig/shared/chart/Chart" });
export type Chart = typeof Chart.Type;

const ChartFile = Schema.fromJsonString(Schema.toCodecJson(Chart));
const decodeChartFile = Schema.decodeUnknownEffect(ChartFile);

// The schema's own message names the measure at fault, which is what the editor of the file needs.
export const decodeChart = (text: string): Effect.Effect<Chart, Errors.BadChart> =>
  Effect.mapError(decodeChartFile(text), (error) =>
    Errors.BadChart.make({ reason: error.message, cause: error }),
  );
